if (!customElements.get('country-language-form')) {
  class CountryLanguageForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const form = this.querySelector('form');
      if (!form) return;

      this.countrySelect = this.querySelector('[data-country-select]');
      this.languageSelect = this.querySelector('[data-language-select]');
      this.screenMain = this.querySelector('[data-screen="main"]');
      this.screenCountryList = this.querySelector('[data-screen="country-list"]');
      this.countryTrigger = this.querySelector('[data-country-trigger]');
      this.countryLabel = this.querySelector('[data-country-label]');
      this.backBtn = this.querySelector('[data-back]');

      if (!this.screenMain || !this.screenCountryList || !this.countrySelect) return;

      this.countryOptions = Array.from(this.querySelectorAll('[data-country-option]'));
      this.languageOptionBtns = Array.from(this.querySelectorAll('[data-language-option]'));
      this.languageOptionsContainer = this.querySelector('[data-language-options]');
      this.currentCountryValue = this.dataset.countryValue;
      this.currentLanguageValue = this.dataset.languageValue;
      
      this.addEventListeners();
    }

    resetToCurrent() {
      if (this.currentCountryValue) {
        this.countrySelect.value = this.currentCountryValue;
        const option = this.countrySelect.querySelector(`option[value="${this.currentCountryValue}"]`);
        if (this.countryLabel && option) {
          this.countryLabel.textContent = option.textContent.trim();
        }
        this.updateCountryTriggerFlag(this.currentCountryValue);
        this.updateCountryOptionCurrent(this.currentCountryValue);
      }
      
      if (this.currentLanguageValue) this.updateLanguageSelection(this.currentLanguageValue);
    }

    updateLanguageSelection(value) {
      if (!value || !this.languageSelect) return;

      this.languageSelect.value = value;
      this.languageOptionBtns.forEach((languageOption) => {
        const isCurrent = languageOption.dataset.value === value;
        languageOption.classList.toggle('country-language-form__option--current', isCurrent);
        languageOption.setAttribute('aria-checked', isCurrent ? 'true' : 'false');
      });
    }

    addEventListeners() {
      this.countryTrigger?.addEventListener('click', () => this.showCountryList());
      this.backBtn?.addEventListener('click', () => this.showMain());

      this.screenCountryList.addEventListener('click', (e) => {
        const countryOption = e.target.closest('[data-country-option]');
        if (countryOption) this.onCountryOptionClick(countryOption);
      });

      if (this.languageOptionsContainer) {
        this.languageOptionsContainer.addEventListener('click', (e) => {
          const languageOption = e.target.closest('[data-language-option]');
          if (languageOption) this.onLanguageOptionClick(languageOption);
        });
      }

      const modal = this.closest('basic-modal');
      if (modal) {
        modal.addEventListener('modal:handleAfterHide', () => {
          this.showMain();
          this.resetToCurrent();
        });
      }
    }

    showMain() {
      this.screenCountryList.hidden = true;
      this.screenMain.hidden = false;

      if (this.countryTrigger) {
        this.countryTrigger.setAttribute('aria-expanded', 'false');
      }

      this.countryTrigger?.focus();
    }

    showCountryList() {
      this.screenMain.hidden = true;
      this.screenCountryList.hidden = false;

      if (this.countryTrigger) {
        this.countryTrigger.setAttribute('aria-expanded', 'true');
      }

      const firstCountryBtn = this.screenCountryList.querySelector('[data-country-option]');
      firstCountryBtn?.focus();
    }

    onCountryOptionClick(btn) {
      const value = btn.dataset.value;
      if (!value || !this.countrySelect) return;

      this.countrySelect.value = value;

      const option = this.countrySelect.querySelector(`option[value="${value}"]`);
      if (this.countryLabel && option) {
        this.countryLabel.textContent = option.textContent.trim();
      }

      this.updateCountryTriggerFlag(value);
      this.updateCountryOptionCurrent(value);
      this.showMain();
    }

    updateCountryTriggerFlag(isoCode) {
      const flagSpan = this.countryTrigger?.querySelector('.country-language-form__flag');
      if (!flagSpan) return;

      flagSpan.className = 'country-language-form__flag f-country-flags f-country-flags--' + isoCode;
      const countryOptionEl = this.countryOptions.find((countryOption) => countryOption.dataset.value === isoCode);
      const sourceFlag = countryOptionEl?.querySelector('.country-language-form__flag');

      if (sourceFlag?.hasAttribute('style')) {
        flagSpan.setAttribute('style', sourceFlag.getAttribute('style'));
      }
    }

    updateCountryOptionCurrent(selectedIsoCode) {
      this.countryOptions.forEach((btn) => {
        const isCurrent = btn.dataset.value === selectedIsoCode;
        btn.classList.toggle('country-language-form__option--current', isCurrent);
      });
    }

    onLanguageOptionClick(btn) {
      const value = btn.dataset.value;
      if (!value || !this.languageSelect) return;

      this.updateLanguageSelection(value);
    }
  }

  customElements.define('country-language-form', CountryLanguageForm);
}
